import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, SecondaryButton, ReviewModal } from '../../components';
import css from './AcceptDeclineRequestButtonsMaybe.css';
import { parse } from '../../util/urlHelpers';
import { compose } from 'redux';
import { createResourceLocatorString } from '../../util/routes';
import routeConfiguration from '../../routeConfiguration';
import { FILTER_SEARCH_PARAM } from '../../containers/TransactionPage/components/Filters';
import { useParamFilters } from '../../hooks/useParamFilters';
import { trimDisplayNameLastWord } from '../../util/text';
import { IconClockL } from '../../icons';
import AcceptDeclineRequestButtonsError from './AcceptDeclineRequestButtonsError';
import { getTimeDiffRepresentation } from '../../util/time';

const AcceptDeclineRequestButtonsMaybe = ({
    onRespondOnCustomerInquiry,
    inquiryError,
    revieweeName,
    currentUser,
    currentListing,
    otherParty,
    match,
    location,
    history,
    transaction,
}) => {
    const transactionRequestInProgress = useSelector(
        s => s.TransactionPage.transactionRequestInProgress
    );
    const { id } = match.params;
    const {
        attributes: {
            profile: {
                displayName,
                publicData: { userType: otherPartyUserType },
            },
        },
    } = otherParty;
    /**
     * lastTransitionedAt should be the time when a transaction is initiated, e.i. "transition/enquire"
     * and is considered to be a substitution for createdAt
     */
    const { lastTransitionedAt } = transaction?.attributes || {};

    const { feedback: declineModalVisible } = parse(location.search) || {};

    const otherPartyName = trimDisplayNameLastWord(displayName);

    const filters = useParamFilters(FILTER_SEARCH_PARAM, location);
    const hasFilters = filters && filters.length > 0;

    const requestDeadlineDate = new Date(lastTransitionedAt);
    requestDeadlineDate.setHours(0, 0, 0, 0);
    requestDeadlineDate.setDate(requestDeadlineDate.getDate() + 14);

    const todayStartDate = new Date(new Date().setHours(0, 0, 0, 0));
    const { days, hours, minutes } = getTimeDiffRepresentation(todayStartDate, requestDeadlineDate);

    const requestDeadline = days || hours || minutes;

    const setDeclineModalVisibility = () => {
        if (declineModalVisible) {
            history.goBack();
        } else {
            const pagename = id ? 'OrderDetailsPage' : 'OrderMessagesPage';

            history.push(
                createResourceLocatorString(
                    pagename,
                    routeConfiguration(),
                    { id },
                    hasFilters
                        ? {
                              [FILTER_SEARCH_PARAM]: filters.join(encodeURIComponent(',')),
                              feedback: 'true',
                          }
                        : { feedback: 'true' }
                )
            );
        }
    };

    return (
        <div className={css.acceptDeclineBtnSection}>
            <div className={css.roundedBadge}>
                <IconClockL />
            </div>
            <h4>Ausstehende Anfrage von {otherPartyName}</h4>
            <p className={css.acceptDeclineDescription}>
                Du hast noch {requestDeadline} Zeit, um zu reagieren. Wenn Du die Anfrage
                akzeptierst, kannst Du {otherPartyName} direkt antworten.
            </p>
            <aside className={css.buttonsSection}>
                <Button
                    className={css.txActionBtn}
                    onClick={() => onRespondOnCustomerInquiry()}
                    inProgress={transactionRequestInProgress}
                >
                    <span>Akzeptieren</span>
                </Button>
                <SecondaryButton
                    className={css.txActionBtn}
                    onClick={() => setDeclineModalVisibility(true)}
                    inProgress={transactionRequestInProgress}
                >
                    <span>Ablehnen & Feedback</span>
                </SecondaryButton>
            </aside>
            <ReviewModal
                id="ReviewOrderModal"
                isOpen={declineModalVisible}
                onClose={setDeclineModalVisibility}
                onRespondOnCustomerInquiry={async ({ feedback, reason }) => {
                    await onRespondOnCustomerInquiry(feedback, reason);
                    setDeclineModalVisibility();
                }}
                revieweeName={revieweeName}
                otherPartyUserType={otherPartyUserType}
                otherParty={otherParty}
                currentUser={currentUser}
                currentListing={currentListing}
                inquiryError={inquiryError}
            />
            <AcceptDeclineRequestButtonsError />
        </div>
    );
};

export default compose(withRouter)(AcceptDeclineRequestButtonsMaybe);
